import PropTypes from 'prop-types';
import Select from 'react-select';

const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: '0.375rem', // ปรับให้ตรงกับ daisyUI (rounded-md)
      borderColor: state.isFocused ? '#2563eb' : '#d1d5db', // blue-600 เมื่อ focus, gray-300 เมื่อไม่ focus
      boxShadow: state.isFocused ? '0 0 0 1px #2563eb' : null,
      '&:hover': { borderColor: state.isFocused ? '#2563eb' : '#d1d5db' },
      minHeight: '3.05rem',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#9ca3af', // gray-400
    }),
    input: (provided) => ({
      ...provided,
      color: '#374151', // gray-700
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '0.375rem',
      marginTop: 4,
    }),
  };

// AddUserModal.jsx
export default function AddUserModal({ 
  newUser, 
  setNewUser, 
  handleAddUser, 
  handleCancelAddUser, 
  errors,
  hospitalOptions  // รับ hospitalOptions จาก parent component
}) {
  // ค้นหา option ที่ตรงกับค่าใน newUser.hospitalName
  const selectedHospital = hospitalOptions.find(
    (option) => option.value === newUser.hospitalName
  ) || null;

  const handleHospitalChange = (selectedOption) => {
    setNewUser({ ...newUser, hospitalName: selectedOption ? selectedOption.value : "" });
  };

  

  return (
    <div className="modal modal-open">
      <div className="modal-box">
        <h3 className="font-bold text-lg mb-4">Add New User</h3>
        <form onSubmit={(e) => {
            e.preventDefault();
            handleAddUser();
        }}>
          {/* Email Field */}
          <div className="form-control">
            <label className="label">
              <span className="label-text">Email</span>
            </label>
            <input
              type="text"
              className={`input input-bordered ${errors.email ? 'input-error' : ''}`}
              value={newUser.email || ''}
              onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
            />
            {errors.email && <span className="text-error text-sm">{errors.email}</span>}
          </div>
          
          {/* Password Field */}
          <div className="form-control mt-4">
            <label className="label">
              <span className="label-text">Password</span>
            </label>
            <input
              type="password"
              className={`input input-bordered ${errors.password ? 'input-error' : ''}`}
              value={newUser.password || ''}
              onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
            />
            {errors.password && <span className="text-error text-sm">{errors.password}</span>}
          </div>
          
          {/* Hospital Name Field as Dropdown */}
          <div className="form-control mt-4">
            <label className="label">
              <span className="label-text">Hospital Name (EN)</span>
            </label>
            <Select
              styles={customStyles}
              options={hospitalOptions}
              value={selectedHospital}
              onChange={handleHospitalChange}
              placeholder="Select Hospital..."
              isClearable
            />
            {errors.hospitalName && <span className="text-error text-sm">{errors.hospitalName}</span>}
          </div>
          
          {/* User Role Field */}
          <div className="form-control mt-4">
            <label className="label">
              <span className="label-text">User Role</span>
            </label>
            <select
              className={`select select-bordered ${errors.role ? 'select-error' : ''}`}
              value={newUser.role || ''}
              onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
            >
              <option value="">Select Role</option>
              <option value="user">Member</option>
              <option value="guest">Guest</option>
            </select>
            {errors.role && <span className="text-error text-sm">{errors.role}</span>}
          </div>
          
          {/* Action Buttons */}
          <div className="modal-action">
            <button type="submit" className="btn btn-primary">Add User</button>
            <button type="button" className="btn" onClick={handleCancelAddUser}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}

AddUserModal.propTypes = {
  newUser: PropTypes.object.isRequired,
  setNewUser: PropTypes.func.isRequired,
  handleAddUser: PropTypes.func.isRequired,
  handleCancelAddUser: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  hospitalOptions: PropTypes.array.isRequired,
};